import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import useFullUrl from "web/core/shop/useFullUrl";

const CategorySeo = (props) => {
  const ogUrl = useFullUrl(props.category.path);

  return (
    <Helmet encodeSpecialCharacters={false}>
      <title>{props.category.meta_title}</title>
      {props.category.meta_description && (
        <meta name="description" content={props.category.meta_description} />
      )}

      {/* Open Graph tags */}
      <meta property="og:title" content={props.category.meta_title} />
      {props.category.meta_description && (
        <meta
          property="og:description"
          content={props.category.meta_description}
        />
      )}
      <meta property="og:url" content={ogUrl} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary" />

      {props.canonicalUrl && <link rel="canonical" href={props.canonicalUrl} />}
    </Helmet>
  );
};

CategorySeo.propTypes = {
  canonicalUrl: PropTypes.string,
};

export default CategorySeo;
